export default {
  userId(state) {
    return state.userName;
  },
  token(state) {
    return state.token;
  },
  isAuthenticated(state) {
    return !!state.token;
  },
  ltsNotification(state) {
    return state.ltsNotification || [];
  }
};